
export default function AboutSection() {
  const highlights = [
    { icon: 'ri-award-line', title: '20+ Años de Experiencia', desc: 'Dedicados al arte del ilusionismo profesional' },
    { icon: 'ri-map-pin-line', title: 'Establecido en Galicia', desc: 'Galicia – Actuaciones a nivel nacional e internacional' },
    { icon: 'ri-mic-line', title: 'Stand-up Magic', desc: 'Concepto innovador que une magia y comedia' },
    { icon: 'ri-heart-line', title: 'Valores Educativos', desc: 'Mensajes positivos en cada presentación' }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-black via-gray-950/30 to-black">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Portrait */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-lg">
              <img 
                src="\images\aboutimage.jfif"
                alt="Marco Pombo - Ilusionista Profesional"
                className="w-full h-[600px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-black/20"></div>
            </div>
          </div>

          {/* Biography */}
          <div className="text-white space-y-6">
            <div>
              <h2 className="font-elegant text-4xl md:text-5xl font-bold mb-6">
                Conoce al <span className="text-red-600">Ilusionista</span>
              </h2>
              
              <div className="space-y-4 text-gray-300 leading-relaxed">
                <p>Marco Pombo es un ilusionista experimentado con más de 20 años dedicados al arte del entretenimiento e ilusionismo. Establecido en Galicia, ha desarrollado un estilo único que combina técnicas clásicas de magia con elementos de stand-up comedy.</p>
                <p>Pionero del concepto innovador de "Stand-up Magic", su propuesta artística va más allá del entretenimiento convencional, incorporando mensajes educativos y valores positivos en presentaciones interactivas que encantan a públicos de todas las edades.</p>
                <p>Con una presencia escénica marcante, fruto de su experiencia como actor, Marco Pombo transforma cada presentación en una experiencia memorable que estimula la imaginación y el pensamiento crítico.</p>
              </div>
            </div>

            {/* Experience Highlights */}
            <div className="grid sm:grid-cols-2 gap-4 pt-8">
              {highlights.map((item, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="w-10 h-10 flex items-center justify-center text-red-600 text-xl">
                    <i className={item.icon}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white">{item.title}</h4>
                    <p className="text-sm text-gray-400">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
